import React from 'react';
import WizardShell from '../components/WizardShell';

function KnowledgeChoice({ totalSteps, onYes, onSkip }) {
  return (
    <WizardShell
      title="Base de conhecimento"
      subtitle="Seu agente pode usar documentos para responder melhor. Quer cadastrar uma base agora?"
      step={1}
      totalSteps={totalSteps}
    >
      <div className="flex flex-col gap-3">
        <button type="button" onClick={onYes} className="btn-primary w-full">
          Sim, adicionar knowledge
        </button>
        <button type="button" onClick={onSkip} className="btn-secondary w-full">
          Pular por agora
        </button>
      </div>
    </WizardShell>
  );
}

export default KnowledgeChoice;
